<template>
  <div>
    <table class="table_flower">
      <tr>
        <th width="20%">申请人姓名</th>
        <td>{{form.applicantName}}</td>
        <th width="20%">申请人身份证号</th>
        <td>{{form.applicantIDCardNo}}</td>
      </tr>
      <tr>
        <th>{{form.applicationType!=$store.state.applicationType['居住证积分续办']?'补交材料要求':"发送内容"}}</th>
        <td colspan="3">
          <div v-for="(prequalificationFeedBack,index) in form.prequalificationFeedBackList" :key="index">
            <strong>{{prequalificationFeedBack.title}}</strong>
            <div style="white-space: pre-line; overflow-wrap: break-word;">{{prequalificationFeedBack.val}}</div>
          </div>
          <div style="white-space: pre-line; overflow-wrap: break-word;">{{form.xbsL_Content}}</div>
        </td>
      </tr>
      <tr>
        <th>补交材料类型</th>
        <td colspan="3">
          <template v-if="form.applicationType==$store.state.applicationType['居住证积分新办']">
            <span v-for="(supplementaryMaterial,index) in form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList" :key="index">
              {{supplementaryMaterial.name}}<span v-if="index<(form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList.length-1)">、</span>
            </span>
          </template>
          <span v-else>{{form.补交材料类型Text}}</span>
        </td>
      </tr>
    </table>
    <div class="bom_btn">
      <div>
        <Button type="primary" @click="next(null,1)">下一步</Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: { type: Object },
  },
  data() {
    return {
      appInfoDataType: this.$store.state.appInfoDataType,
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      if (name === null) {
        this.$emit('next', val)
        return
      }
    },
  },
}
</script>
